import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/shared/services/REST-API/rest.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalVarService } from 'src/shared/services/global-var.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ClanDialogBoxComponent } from './clan-dialog-box/clan-dialog-box.component';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-profile-screen',
  templateUrl: './profile-screen.component.html',
  styleUrls: ['./profile-screen.component.css']
})
export class ProfileScreenComponent implements OnInit {
  userProfile;
  userdetails;
  avatar;
  fileToUpload: File;
  constructor(private authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    private globalVar: GlobalVarService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.spinner.show();
    this.authService.user.subscribe((user) => {
      this.userProfile = user;
    });
    this.authService.getuserdetail().subscribe((data) => {
      if (!data) { return }
      this.userdetails = data;
      this.spinner.hide();
    });
    this.subAvatar();

  }

  naviagteToClickedEvent(event_id) {
    this.router.navigate(['/events'], { queryParams: { event_id } })
  }

  getAvatar() {
    this.authService.getAvatar().subscribe((data) => {
      if (JSON.stringify(data) === '{}') { return }
      var uints = new Uint8Array(data.binary.data);
      var image = btoa(String.fromCharCode.apply(null, uints));
      const avatar = this.sanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,' + image);
      this.globalVar.avatarBinary.next(avatar)
      this.subAvatar();
    })
  }
  subAvatar() {
    this.globalVar.avatarBinary.subscribe((data) => {
      this.avatar = data;
    })
  }

  uploadAvatar(files: FileList) {
    this.fileToUpload = files.item(0);
    const formData: FormData = new FormData();
    formData.append('name', this.fileToUpload, this.fileToUpload.name);
    this.authService.setAvatar(formData).subscribe((data) => {
      this.getAvatar()
    })
  }
  clanSetting(clan_id) {
    if (clan_id) {
      this.router.navigate(['/clan'], { queryParams: { clan_id } })
    } else {
      this.openDialog();
    }

  }
  openDialog(): void {
    const dialogRef = this.dialog.open(ClanDialogBoxComponent, {

    });

    dialogRef.afterClosed().subscribe(result => {
      this.userdetails.clan.clanName = result?.clanName
    });
  }
}
